import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f2a284"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "После создания тикета начнется загрузка файлов из тикета ", -1))

import { computed, PropType } from "vue";
import { TirPmPlate } from "tir-components";
import { PaperClipIcon } from "tir-style-system/icons/outline";
import { TaskImportServiceEnum } from "@/enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-import-files-alert',
  props: {
  /**Сервис импорта */
  importService: {
    type: String as PropType<TaskImportServiceEnum>,
    required: true,
  },
  /**Ссылка на задачу */
  taskUrl: { type: String },
},
  setup(__props) {

const props = __props;



const serviceName = computed(() => {
  switch (props.importService) {
    case TaskImportServiceEnum.Weeek:
      return "Weeek";
  }
});

const serviceNameTag = computed(() => (props.taskUrl ? "a" : "span"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPlate), {
    class: "task-import-files-alert",
    "is-show": true,
    "is-rounded": ""
  }, {
    leftAddon: _withCtx(() => [
      _createVNode(_unref(PaperClipIcon), { class: "task-import-files-alert__icon" })
    ]),
    titleSlot: _withCtx(() => [
      _createTextVNode(" В импортированном тикете есть прикрепленные файлы ")
    ]),
    subtitleSlot: _withCtx(() => [
      _hoisted_1,
      (serviceName.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(serviceNameTag.value), {
            key: 0,
            href: __props.taskUrl,
            target: __props.taskUrl && '_blank'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(serviceName.value), 1)
            ]),
            _: 1
          }, 8, ["href", "target"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})